import { render, staticRenderFns } from "./warnTable.vue?vue&type=template&id=1afb100f&scoped=true&"
import script from "./warnTable.vue?vue&type=script&lang=js&"
export * from "./warnTable.vue?vue&type=script&lang=js&"
import style0 from "./warnTable.vue?vue&type=style&index=0&id=1afb100f&lang=less&scoped=true&"
import style1 from "./warnTable.vue?vue&type=style&index=1&id=1afb100f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb100f",
  null
  
)

export default component.exports